<template>
  <FullWidth v-bind:returnTo="'Home'">
    
    <div slot="left-content" class="spacer-content">
        <!--<a href="https://altarea-cogedim.iframe.evimmo.fr/services/iframev4/maquette?p=151618" target="_blank">
            <div class="cta">
                Décrouvrez la maquette du projet
            </div>
            
            <img src="../../assets/preview-maquette.png" class="img-fluid" />
        </a>-->
        <iframe class="embed-responsive-item" src="https://altarea-cogedim.iframe.evimmo.fr/services/iframev4/maquette?p=151618%22%20target=%22_blank" frameborder="0" allowfullscreen=""></iframe>
    </div> 
    
  </FullWidth>
</template>

<style lang="scss" scoped>
    .cta {
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        background-color: #42145f;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-size: 20px;
        a {
            color: white;
            &:hover {
                color: white;
            }
        }
    }
    .embed-responsive-item {
        width: 100%;
        height: 520px;
        @media (min-width: 992px) {
            height: 580px;
        }
    }
    .spacer-content {
        @media (min-width: 992px) {
            padding-top: 170px !important;
            padding-bottom: 0px !important;
        }
    }
</style>

<script>
// @ is an alias to /src

import FullWidth from '@/components/FullWidth.vue';
 
export default {
  name: 'Maquette',
  components: {
    FullWidth
  },
  data: () => {
      
        return { 
            
        };
    },
  
};
</script>